import React from "react";
import { Accordion } from "react-bootstrap";
import { serverFormatToDateString } from "../../../system";
import fileIcon from "../../../assets/images/icon/fileIcon.svg";
import { TableViewIcon } from "../../../assets/images/icon/iconsProvider";
import { useTranslation } from "react-i18next";
import {
  boatTypeEnumReversed,
  levelEnumReversed,
  proficiencyLevelEnumReversed,
  sportConstantsReversed,
  timezoneConstants,
  translationConstants,
} from "../../../constants";

const CertificateDetails = ({ fileDetails }) => {
  const { t } = useTranslation();

  const renderGridItem = (label, value) => (
    <div className="approval-modal-grid-item">
      <div className="fw-bold">
        {label}:<span className="font-12 fw-normal px-2">{value}</span>
      </div>
    </div>
  );

  return (
    <>
      <div className="approval-modal-grid-container">
        {renderGridItem(
          t(translationConstants.SPORT),
          t(translationConstants[sportConstantsReversed[fileDetails?.sportId]])
        )}
        {renderGridItem(
          t(translationConstants.BOAT_TYPE),
          t(translationConstants[boatTypeEnumReversed[fileDetails?.boatTypeId]])
        )}
        {renderGridItem(
          t(translationConstants.DATE_OF_COMPLETION),
          serverFormatToDateString(
            fileDetails?.dateOfCompletionString,
            timezoneConstants.dayMonthYearFormat
          )
        )}
        {renderGridItem(
          t(translationConstants.SUGGESTED_LEVEL),
          t(translationConstants[levelEnumReversed[fileDetails?.levelId]])
        )}
      </div>
      {fileDetails?.proficiencyLevelId && (
        <div className="font-14 fw-bold pt-3">
          {t(translationConstants.SUGGESTED_PROFICIENCY_LEVEL)}:
          <span className="font-12 fw-normal px-2">
            {t(
              translationConstants[
                proficiencyLevelEnumReversed[fileDetails?.proficiencyLevelId]
              ]
            )}
          </span>
        </div>
      )}
      <Accordion className="approval-modal-accordion my-3" defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {t(translationConstants.ATTACHMENTS)}:
          </Accordion.Header>
          <Accordion.Body className="accordion-body-one">
            {fileDetails?.qualifications.map((file) => (
              <div
                key={file.documentId}
                className="d-flex mb-2 justify-content-between align-items-center"
              >
                <div className="accordionInnerFiles text-truncate ">
                  <img src={fileIcon} alt="" />
                  {file.originalFileName}
                </div>
                <div className="iconDiv">
                  <TableViewIcon onClick={() => window.open(file.link)} />
                </div>
              </div>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default CertificateDetails;
